'use es6';

import { Record } from 'immutable';
export default Record({
  communicationTypeId: null,
  consented: false,
  required: false
}, 'LegalCommunicationConsent');